import {
  WebViewAction,
  WebViewActionPayloadMap,
} from "@/components/webview/type/bridge";
import { isProd } from "@/Env";

interface AndroidBridge {
  postMessage: (message: string) => void;
  // 네이티브에서 콜백으로 호출할 함수 시그니처 확장
}

interface iOSWebKit {
  messageHandlers?: {
    iOSBridge?: {
      postMessage: (message: string) => void;
    };
  };
}

declare global {
  interface Window {
    AndroidBridge?: AndroidBridge;
    webkit?: iOSWebKit;
    nativeWebViewCallback?: (
      callbackId: string,
      response: WebViewBridgeResponse,
    ) => void;
  }
}

/*
   WebView , Android 비동기 콜백을 관리 Map
 */
export const callbackMap: Record<string, (res: WebViewBridgeResponse) => void> =
  {};
let callbackIdSeed = 0;
function generateCallbackId() {
  return `cb_${Date.now()}_${callbackIdSeed++}`;
}

export interface WebViewBridgeRequest<T = any> {
  action: WebViewAction;
  payload?: T;
  callbackId?: string;
}

export interface WebViewBridgeResponse<T = any> {
  status: boolean;
  payload: T | null;
  errorMessage: string | null;
  // timestamp: number;
  action: WebViewAction;
}

/*
 webview -> 앱 데이터 통신
 */
export function sendToWithCallbackWebView<
  Action extends WebViewAction,
>(params: {
  action: Action;
  payload: WebViewActionPayloadMap[Action];
}): Promise<any> {
  return new Promise((resolve, reject) => {
    const callbackId = generateCallbackId();

    callbackMap[callbackId] = (response: WebViewBridgeResponse) => {
      if (!response.status) reject(Response.error);
      else resolve(response.payload!);
    };

    const message: WebViewBridgeRequest = {
      action: params.action,
      payload: params.payload,
      callbackId,
    };
    const messageString = JSON.stringify(message);

    if (window.webkit?.messageHandlers?.iOSBridge) {
      // Send message to iOS WebView
      window.webkit.messageHandlers.iOSBridge.postMessage(messageString);
    } else if (window.AndroidBridge) {
      // Send message to Android WebView
      window.AndroidBridge.postMessage(messageString);
    } else {
      // No webview bridge found, reject promise to prevent hanging
      const err = new Error("WebView bridge is not available.");
      if (!isProd) {
        console.warn(`${err.message} (action: ${params.action})`);
      }
      reject(err);
    }
  });
}

/*
 앱에서 사용자 브라우저를 켜기위한 bridge event 함수
 */
export async function openBrowserWebView({
  url,
  directUrl,
}: {
  url?: string;
  directUrl?: string;
}) {
  const domain = isProd
    ? "https://www.bhaptics.com"
    : "https://dev.bhaptics.com";

  try {
    if (directUrl) {
      const result = await sendToWithCallbackWebView({
        action: WebViewAction.OpenWebBrowser,
        payload: { url: `${directUrl}` },
      });
      return;
    }
    const result = await sendToWithCallbackWebView({
      action: WebViewAction.OpenWebBrowser,
      payload: { url: `${domain}/${url}` },
    });
  } catch (err) {
    //TODO 에러 핸들링 (네이티브에서 에러 발생시)
  }
}
